import {
  constructDisplayPercentage,
  constructShortenedFinancialNumber,
} from "utils/general";

import Locale from "react-intl-universal";

const constructDisplayNumber = (value) =>
  value ? Number(value).toFixed(2) : 0;
const constructTPDCoverageValue = (coverage) =>
  coverage && coverage.value
    ? `${coverage.value.isGreaterThan ? "> " : ""}${constructDisplayNumber(
        coverage.value.value
      )}`
    : 0;

const constructNaturalDeathCoverageDataSource = (
  currentValue = {},
  optimisedValue = {}
) => [
  {
    label: Locale.get("reporting.coverRatio"),
    desc: Locale.get("reporting.coverRatioDesc"),
    range:
      (currentValue.coverRatio &&
        `${currentValue.coverRatio.optimalRange.min} - ${currentValue.coverRatio.optimalRange.max}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.coverRatio && currentValue.coverRatio.value
    ),
    isInRange:
      currentValue.coverRatio &&
      currentValue.coverRatio.value >=
        currentValue.coverRatio.optimalRange.min &&
      currentValue.coverRatio.value <= currentValue.coverRatio.optimalRange.max,
    optimisedValue: constructDisplayNumber(
      optimisedValue.coverRatio && optimisedValue.coverRatio.value
    ),
    isOptimisedInRange:
      optimisedValue.coverRatio &&
      optimisedValue.coverRatio.value >=
        optimisedValue.coverRatio.optimalRange.min &&
      optimisedValue.coverRatio.value <=
        optimisedValue.coverRatio.optimalRange.max,
  },
  {
    label: Locale.get("reporting.dtf"),
    desc: Locale.get("reporting.dtfDesc"),
    range:
      (currentValue.dtf &&
        `> ${currentValue.dtf.optimalRange.min} ${Locale.get(
          "reporting.months"
        )}`) ||
      "-",
    value: constructDisplayNumber(currentValue.dtf && currentValue.dtf.value),
    isInRange:
      currentValue.dtf &&
      currentValue.dtf.value >= currentValue.dtf.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.dtf && optimisedValue.dtf.value
    ),
    isOptimisedInRange:
      optimisedValue.dtf &&
      optimisedValue.dtf.value >= optimisedValue.dtf.optimalRange.min,
  },
  {
    label: Locale.get("reporting.dbf"),
    desc: Locale.get("reporting.dbfDesc"),
    range:
      (currentValue.dbf &&
        `> ${currentValue.dbf.optimalRange.min} ${Locale.get(
          "reporting.months"
        )}`) ||
      "-",
    value: constructDisplayNumber(currentValue.dbf && currentValue.dbf.value),
    isInRange:
      currentValue.dbf &&
      currentValue.dbf.value >= currentValue.dbf.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.dbf && optimisedValue.dbf.value
    ),
    isOptimisedInRange:
      optimisedValue.dbf &&
      optimisedValue.dbf.value >= optimisedValue.dbf.optimalRange.min,
  },
  {
    label: Locale.get("reporting.duf"),
    desc: Locale.get("reporting.dufDesc"),
    range:
      (currentValue.duf &&
        `> ${currentValue.duf.optimalRange.min} ${Locale.get(
          "reporting.months"
        )}`) ||
      "-",
    value: constructDisplayNumber(currentValue.duf && currentValue.duf.value),
    isInRange:
      currentValue.duf &&
      currentValue.duf.value >= currentValue.duf.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.duf && optimisedValue.duf.value
    ),
    isOptimisedInRange:
      optimisedValue.duf &&
      optimisedValue.duf.value >= optimisedValue.duf.optimalRange.min,
  },
  {
    label: Locale.get("reporting.tFundingSolution"),
    desc: Locale.get("reporting.tFundingSolutionDesc"),
    range:
      (currentValue.totalIFS &&
        `> ${constructDisplayPercentage(
          currentValue.totalIFS.optimalRange.min
        )}`) ||
      "-",
    value: constructDisplayPercentage(
      currentValue.totalIFS && currentValue.totalIFS.value
    ),
    isInRange:
      currentValue.totalIFS &&
      currentValue.totalIFS.value >= currentValue.totalIFS.optimalRange.min,
    optimisedValue: constructDisplayPercentage(
      optimisedValue.totalIFS && optimisedValue.totalIFS.value
    ),
    isOptimisedInRange:
      optimisedValue.totalIFS &&
      optimisedValue.totalIFS.value >= optimisedValue.totalIFS.optimalRange.min,
  },
  {
    label: Locale.get("reporting.bFundingSolution"),
    desc: Locale.get("reporting.bFundingSolutionDesc"),
    range:
      (currentValue.basicIFS &&
        `> ${constructDisplayPercentage(
          currentValue.basicIFS.optimalRange.min
        )}`) ||
      "-",
    value: constructDisplayPercentage(
      currentValue.basicIFS && currentValue.basicIFS.value
    ),
    isInRange:
      currentValue.basicIFS &&
      currentValue.basicIFS.value >= currentValue.basicIFS.optimalRange.min,
    optimisedValue: constructDisplayPercentage(
      optimisedValue.basicIFS && optimisedValue.basicIFS.value
    ),
    isOptimisedInRange:
      optimisedValue.basicIFS &&
      optimisedValue.basicIFS.value >= optimisedValue.basicIFS.optimalRange.min,
  },
];

const constructAccidentalDeathCoverageDataSource = (
  currentValue = {},
  optimisedValue = {}
) => [
  {
    label: Locale.get("reporting.aDtf"),
    desc: Locale.get("reporting.aDtfDesc"),
    range:
      (currentValue.dtf &&
        `> ${currentValue.dtf.optimalRange.min} ${Locale.get(
          "reporting.months"
        )}`) ||
      "-",
    value: constructDisplayNumber(currentValue.dtf && currentValue.dtf.value),
    isInRange:
      currentValue.dtf &&
      currentValue.dtf.value >= currentValue.dtf.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.dtf && optimisedValue.dtf.value
    ),
    isOptimisedInRange:
      optimisedValue.dtf &&
      optimisedValue.dtf.value >= optimisedValue.dtf.optimalRange.min,
  },
  {
    label: Locale.get("reporting.aDbf"),
    desc: Locale.get("reporting.aDbfDesc"),
    range:
      (currentValue.dbf &&
        `> ${currentValue.dbf.optimalRange.min} ${Locale.get(
          "reporting.months"
        )}`) ||
      "-",
    value: constructDisplayNumber(currentValue.dbf && currentValue.dbf.value),
    isInRange:
      currentValue.dbf &&
      currentValue.dbf.value >= currentValue.dbf.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.dbf && optimisedValue.dbf.value
    ),
    isOptimisedInRange:
      optimisedValue.dbf &&
      optimisedValue.dbf.value >= optimisedValue.dbf.optimalRange.min,
  },
  {
    label: Locale.get("reporting.aDuf"),
    desc: Locale.get("reporting.aDufDesc"),
    range:
      (currentValue.duf &&
        `> ${currentValue.duf.optimalRange.min} ${Locale.get(
          "reporting.months"
        )}`) ||
      "-",
    value: constructDisplayNumber(currentValue.duf && currentValue.duf.value),
    isInRange:
      currentValue.duf &&
      currentValue.duf.value >= currentValue.duf.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.duf && optimisedValue.duf.value
    ),
    isOptimisedInRange:
      optimisedValue.duf &&
      optimisedValue.duf.value >= optimisedValue.duf.optimalRange.min,
  },
  {
    label: Locale.get("reporting.aTFundingSolution"),
    desc: Locale.get("reporting.aTFundingSolutionDesc"),
    range:
      (currentValue.totalIFS &&
        `> ${constructDisplayPercentage(
          currentValue.totalIFS.optimalRange.min
        )}`) ||
      "-",
    value: constructDisplayPercentage(
      currentValue.totalIFS && currentValue.totalIFS.value
    ),
    isInRange:
      currentValue.totalIFS &&
      currentValue.totalIFS.value >= currentValue.totalIFS.optimalRange.min,
    optimisedValue: constructDisplayPercentage(
      optimisedValue.totalIFS && optimisedValue.totalIFS.value
    ),
    isOptimisedInRange:
      optimisedValue.totalIFS &&
      optimisedValue.totalIFS.value >= optimisedValue.totalIFS.optimalRange.min,
  },
  {
    label: Locale.get("reporting.aBFundingSolution"),
    desc: Locale.get("reporting.aBFundingSolutionDesc"),
    range:
      (currentValue.basicIFS &&
        `> ${constructDisplayPercentage(
          currentValue.basicIFS.optimalRange.min
        )}`) ||
      "-",
    value: constructDisplayPercentage(
      currentValue.basicIFS && currentValue.basicIFS.value
    ),
    isInRange:
      currentValue.basicIFS &&
      currentValue.basicIFS.value >= currentValue.basicIFS.optimalRange.min,
    optimisedValue: constructDisplayPercentage(
      optimisedValue.basicIFS && optimisedValue.basicIFS.value
    ),
    isOptimisedInRange:
      optimisedValue.basicIFS &&
      optimisedValue.basicIFS.value >= optimisedValue.basicIFS.optimalRange.min,
  },
];

const constructCIMedicalBenefitCoverageDataSource = (
  currentValue = {},
  optimisedValue = {},
  personalDetails = {}
) => [
  {
    label: Locale.get("reporting.ciMonthlyExp"),
    desc: Locale.get("reporting.ciMonthlyExpDesc"),
    range:
      (currentValue.ciMonthlyExpenses &&
        `${currentValue.ciMonthlyExpenses.optimalRange.min} - ${
          currentValue.ciMonthlyExpenses.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.ciMonthlyExpenses && currentValue.ciMonthlyExpenses.value
    ),
    isInRange:
      currentValue.ciMonthlyExpenses &&
      currentValue.ciMonthlyExpenses.value >=
        currentValue.ciMonthlyExpenses.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.ciMonthlyExpenses && optimisedValue.ciMonthlyExpenses.value
    ),
    isOptimisedInRange:
      optimisedValue.ciMonthlyExpenses &&
      optimisedValue.ciMonthlyExpenses.value >=
        optimisedValue.ciMonthlyExpenses.optimalRange.min,
  },
  {
    label: Locale.get("reporting.ciRrfMonthlyExp"),
    desc: Locale.get("reporting.ciRrfMonthlyExpDesc"),
    range:
      (currentValue.ciRRFMonthlyExpenses &&
        `${currentValue.ciRRFMonthlyExpenses.optimalRange.min} - ${
          currentValue.ciRRFMonthlyExpenses.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.ciRRFMonthlyExpenses &&
        currentValue.ciRRFMonthlyExpenses.value
    ),
    isInRange:
      currentValue.ciRRFMonthlyExpenses &&
      currentValue.ciRRFMonthlyExpenses.value >=
        currentValue.ciRRFMonthlyExpenses.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.ciRRFMonthlyExpenses &&
        optimisedValue.ciRRFMonthlyExpenses.value
    ),
    isOptimisedInRange:
      optimisedValue.ciRRFMonthlyExpenses &&
      optimisedValue.ciRRFMonthlyExpenses.value >=
        optimisedValue.ciRRFMonthlyExpenses.optimalRange.min,
  },
  {
    label: Locale.get("reporting.eCiMonthlyExp"),
    desc: Locale.get("reporting.eCiMonthlyExpDesc"),
    range:
      (currentValue.earlyCIMonthlyExpenses &&
        `${currentValue.earlyCIMonthlyExpenses.optimalRange.min} - ${
          currentValue.earlyCIMonthlyExpenses.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.earlyCIMonthlyExpenses &&
        currentValue.earlyCIMonthlyExpenses.value
    ),
    isInRange:
      currentValue.earlyCIMonthlyExpenses &&
      currentValue.earlyCIMonthlyExpenses.value >=
        currentValue.earlyCIMonthlyExpenses.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.earlyCIMonthlyExpenses &&
        optimisedValue.earlyCIMonthlyExpenses.value
    ),
    isOptimisedInRange:
      optimisedValue.earlyCIMonthlyExpenses &&
      optimisedValue.earlyCIMonthlyExpenses.value >=
        optimisedValue.earlyCIMonthlyExpenses.optimalRange.min,
  },
  {
    label: Locale.get("reporting.eCiRrfMonthlyExp"),
    desc: Locale.get("reporting.eCiRrfMonthlyExpDesc"),
    range:
      (currentValue.earlyCIRRFMonthlyExpenses &&
        `${currentValue.earlyCIRRFMonthlyExpenses.optimalRange.min} - ${
          currentValue.earlyCIRRFMonthlyExpenses.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.earlyCIRRFMonthlyExpenses &&
        currentValue.earlyCIRRFMonthlyExpenses.value
    ),
    isInRange:
      currentValue.earlyCIRRFMonthlyExpenses &&
      currentValue.earlyCIRRFMonthlyExpenses.value >=
        currentValue.earlyCIRRFMonthlyExpenses.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.earlyCIRRFMonthlyExpenses &&
        optimisedValue.earlyCIRRFMonthlyExpenses.value
    ),
    isOptimisedInRange:
      optimisedValue.earlyCIRRFMonthlyExpenses &&
      optimisedValue.earlyCIRRFMonthlyExpenses.value >=
        optimisedValue.earlyCIRRFMonthlyExpenses.optimalRange.min,
  },
  {
    label: Locale.get("reporting.basicCiIfs"),
    desc: Locale.get("reporting.basicCiIfsDesc"),
    range:
      (currentValue.basicCIIFS &&
        `> ${constructDisplayPercentage(
          currentValue.basicCIIFS.optimalRange.min
        )}`) ||
      "-",
    value: constructDisplayPercentage(
      currentValue.basicCIIFS && currentValue.basicCIIFS.value
    ),
    isInRange:
      currentValue.basicCIIFS &&
      currentValue.basicCIIFS.value >= currentValue.basicCIIFS.optimalRange.min,
    optimisedValue: constructDisplayPercentage(
      optimisedValue.basicCIIFS && optimisedValue.basicCIIFS.value
    ),
    isOptimisedInRange:
      optimisedValue.basicCIIFS &&
      optimisedValue.basicCIIFS.value >=
        optimisedValue.basicCIIFS.optimalRange.min,
  },
  {
    label: Locale.get("reporting.compCiIfs"),
    desc: Locale.get("reporting.compCiIfs"),
    range:
      (currentValue.completeCIIFS &&
        `> ${constructDisplayPercentage(
          currentValue.completeCIIFS.optimalRange.min
        )}`) ||
      "-",
    value: constructDisplayPercentage(
      currentValue.completeCIIFS && currentValue.completeCIIFS.value
    ),
    isInRange:
      currentValue.completeCIIFS &&
      currentValue.completeCIIFS.value >=
        currentValue.completeCIIFS.optimalRange.min,
    optimisedValue: constructDisplayPercentage(
      optimisedValue.completeCIIFS && optimisedValue.completeCIIFS.value
    ),
    isOptimisedInRange:
      optimisedValue.completeCIIFS &&
      optimisedValue.completeCIIFS.value >=
        optimisedValue.completeCIIFS.optimalRange.min,
  },
  {
    label:
      Locale.get("reporting.mhi") +
      " " +
      constructShortenedFinancialNumber(
        personalDetails.medicalHealthInsuranceNeeds,
        false
      ),
    desc: Locale.get("reporting.mhiDesc"),
    range:
      (currentValue.mhiFunding &&
        `> ${currentValue.mhiFunding.optimalRange.min} ${Locale.get(
          "reporting.times"
        )}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.mhiFunding && currentValue.mhiFunding.value
    ),
    isInRange:
      currentValue.mhiFunding &&
      currentValue.mhiFunding.value >= currentValue.mhiFunding.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.mhiFunding && optimisedValue.mhiFunding.value
    ),
    isOptimisedInRange:
      optimisedValue.mhiFunding &&
      optimisedValue.mhiFunding.value >=
        optimisedValue.mhiFunding.optimalRange.min,
  },
  {
    label:
      Locale.get("reporting.mhiCi") +
      " " +
      constructShortenedFinancialNumber(
        personalDetails.medicalHealthInsuranceNeeds,
        false
      ),
    desc: Locale.get("reporting.mhiDesc"),
    range:
      (currentValue.mhiCIFunding &&
        `> ${currentValue.mhiCIFunding.optimalRange.min} ${Locale.get(
          "reporting.times"
        )}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.mhiCIFunding && currentValue.mhiCIFunding.value
    ),
    isInRange:
      currentValue.mhiCIFunding &&
      currentValue.mhiCIFunding.value >=
        currentValue.mhiCIFunding.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.mhiCIFunding && optimisedValue.mhiCIFunding.value
    ),
    isOptimisedInRange:
      optimisedValue.mhiCIFunding &&
      optimisedValue.mhiCIFunding.value >=
        optimisedValue.mhiCIFunding.optimalRange.min,
  },
];

const constructTPDCoverageDataSource = (
  currentValue = {},
  optimisedValue = {}
) => [
  {
    label: Locale.get("reporting.tpdTotalMonthExp"),
    desc: Locale.get("reporting.tpdTotalMonthExpDesc"),
    range:
      (currentValue.tpdToUME &&
        `${currentValue.tpdToUME.optimalRange.min} - ${
          currentValue.tpdToUME.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructTPDCoverageValue(currentValue.tpdToUME),
    isInRange:
      currentValue.tpdToUME &&
      (currentValue.tpdToUME.value.isGreaterThan ||
        currentValue.tpdToUME.value.value >=
          currentValue.tpdToUME.optimalRange.min),
    optimisedValue: constructTPDCoverageValue(optimisedValue.tpdToUME),
    isOptimisedInRange:
      optimisedValue.tpdToUME &&
      (optimisedValue.tpdToUME.value.isGreaterThan ||
        optimisedValue.tpdToUME.value.value >=
          optimisedValue.tpdToUME.optimalRange.min),
  },
  {
    label: Locale.get("reporting.tpdXHome"),
    desc: Locale.get("reporting.tpdXHomeDesc"),
    range:
      (currentValue.tpdToBME &&
        `${currentValue.tpdToBME.optimalRange.min} - ${
          currentValue.tpdToBME.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructTPDCoverageValue(currentValue.tpdToBME),
    isInRange:
      currentValue.tpdToBME &&
      (currentValue.tpdToBME.value.isGreaterThan ||
        currentValue.tpdToBME.value.value >=
          currentValue.tpdToBME.optimalRange.min),
    optimisedValue: constructTPDCoverageValue(optimisedValue.tpdToBME),
    isOptimisedInRange:
      optimisedValue.tpdToBME &&
      (optimisedValue.tpdToBME.value.isGreaterThan ||
        optimisedValue.tpdToBME.value.value >=
          optimisedValue.tpdToBME.optimalRange.min),
  },
  {
    label: Locale.get("reporting.accidentalTpdMonthExp"),
    desc: Locale.get("reporting.tpdTotalMonthExpDesc"),
    range:
      (currentValue.accTPDToUME &&
        `${currentValue.accTPDToUME.optimalRange.min} - ${
          currentValue.accTPDToUME.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructTPDCoverageValue(currentValue.accTPDToUME),
    isInRange:
      currentValue.accTPDToUME &&
      (currentValue.accTPDToUME.value.isGreaterThan ||
        currentValue.accTPDToUME.value.value >=
          currentValue.accTPDToUME.optimalRange.min),
    optimisedValue: constructTPDCoverageValue(optimisedValue.accTPDToUME),
    isOptimisedInRange:
      optimisedValue.accTPDToUME &&
      (optimisedValue.accTPDToUME.value.isGreaterThan ||
        optimisedValue.accTPDToUME.value.value >=
          optimisedValue.accTPDToUME.optimalRange.min),
  },
  {
    label: Locale.get("reporting.accidentalXHome"),
    desc: Locale.get("reporting.accidentalXHomeDesc"),
    range:
      (currentValue.acTPDToBME &&
        `${currentValue.acTPDToBME.optimalRange.min} - ${
          currentValue.acTPDToBME.optimalRange.max
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructTPDCoverageValue(currentValue.acTPDToBME),
    isInRange:
      currentValue.acTPDToBME &&
      (currentValue.acTPDToBME.value.isGreaterThan ||
        currentValue.acTPDToBME.value.value >=
          currentValue.acTPDToBME.optimalRange.min),
    optimisedValue: constructTPDCoverageValue(optimisedValue.acTPDToBME),
    isOptimisedInRange:
      optimisedValue.acTPDToBME &&
      (optimisedValue.acTPDToBME.value.isGreaterThan ||
        optimisedValue.acTPDToBME.value.value >=
          optimisedValue.acTPDToBME.optimalRange.min),
  },
];

const constructComatoseCoverageDataSource = (
  currentValue = {},
  optimisedValue = {}
) => [
  {
    label: Locale.get("reporting.post30Days"),
    desc: Locale.get("reporting.post30DaysDesc"),
    range:
      (currentValue.comatose &&
        currentValue.comatose.post30DaysSurvival &&
        `${
          currentValue.comatose.post30DaysSurvival.optimalRange.min
        } ${Locale.get("reporting.months")}`) ||
      "-",
    value: constructDisplayNumber(
      currentValue.comatose &&
        currentValue.comatose.post30DaysSurvival &&
        currentValue.comatose.post30DaysSurvival.value
    ),
    isInRange:
      currentValue.comatose &&
      currentValue.comatose.post30DaysSurvival &&
      currentValue.comatose.post30DaysSurvival.value >=
        currentValue.comatose.post30DaysSurvival.optimalRange.min,
    optimisedValue: constructDisplayNumber(
      optimisedValue.comatose &&
        optimisedValue.comatose.post30DaysSurvival &&
        optimisedValue.comatose.post30DaysSurvival.value
    ),
    isOptimisedInRange:
      optimisedValue.comatose &&
      optimisedValue.comatose.post30DaysSurvival &&
      optimisedValue.comatose.post30DaysSurvival.value >=
        optimisedValue.comatose.post30DaysSurvival.optimalRange.min,
  },
  {
    label: Locale.get("reporting.post6Months"),
    desc: Locale.get("reporting.post6MonthsDesc"),
    range: "-",
    value:
      currentValue.tpd && constructTPDCoverageValue(currentValue.tpd.tpdToUME),
    optimisedValue:
      optimisedValue.tpd &&
      constructTPDCoverageValue(optimisedValue.tpd.tpdToUME),
  },
];

export const getReportingData = (
  currentValue = {},
  optimisedValue = {},
  personalDetails = {}
) => {
  if (currentValue) {
    return {
      naturalDeathCoverageData: constructNaturalDeathCoverageDataSource(
        currentValue.naturalDeath,
        optimisedValue.naturalDeath
      ),
      accidentalDeathCoverageData: constructAccidentalDeathCoverageDataSource(
        currentValue.accidentalDeath,
        optimisedValue.accidentalDeath
      ),

      medicalBenefitCoverageData: constructCIMedicalBenefitCoverageDataSource(
        currentValue.ci,
        optimisedValue.ci,
        personalDetails
      ),
      tpdCoverageData: constructTPDCoverageDataSource(
        currentValue.tpd,
        optimisedValue.tpd
      ),
      comatoseCoverageData: constructComatoseCoverageDataSource(
        currentValue,
        optimisedValue
      ),
    };
  }
  return {};
};
